// Determines which languages are supported by this documentation page
// And hides all languages not present on the page
// If an explicit list of languages is provided in the page meta data
// then only those explicit langs are supported, but must still be present
// on the page

export default function setupPermittedLanguages() {
  const { permittedLanguageKeys, navigationLanguages } = this;
  let contentLangs = Array.from(document.querySelectorAll('pre[lang],div[lang],span[lang]'));

  if (!contentLangs || !contentLangs.length) {
    this.permittedLanguages([]);
    return [];
  }

  // From DOM collection, extract Directory of unique keys (eg: { "javascript": true })
  contentLangs = Object.assign.apply(
    {},
    contentLangs.map(el => ({ [el.getAttribute('lang')]: true })),
  );

  // flatten to Array and filter non-permitted languages
  contentLangs = Object.keys(contentLangs).filter(lang => permittedLanguageKeys.indexOf(lang) + 1);

  const languageOptionsForNav = [];
  contentLangs.forEach(languages => {
    languages.split(',').forEach(language => {
      if (languageOptionsForNav.indexOf(language) + 1) return;
      languageOptionsForNav.push(language);
    });
  });

  let permittedLanguagesInNav = languageOptionsForNav;
  if (navigationLanguages != null && navigationLanguages.length > 0) {
    permittedLanguagesInNav = [];
    languageOptionsForNav.forEach(language => {
      if (navigationLanguages.indexOf(language) < 0) return;
      permittedLanguagesInNav.push(language);
    });
  }

  this.permittedLanguages(permittedLanguagesInNav);
  return permittedLanguagesInNav;
}
